import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router'

const homePageRoutes = [
  '/:regionCode/',
]

/**
 * Tells us whether we are currently on the home page or not
 */
function useIsHomePage() {
  const location = useLocation()
  return useMemo(() => {
    return !!matchPath(location.pathname, { path: homePageRoutes, exact: true })
  }, [location.pathname])
}

export default useIsHomePage
